import {React, Component, Container} from 'utils';
import {SelectedPavilionStore, FairStore, App} from 'model';
import {withRouter} from 'react-router-dom';

class PavilionTitle extends Component {

	static getStores()
	{
		return [SelectedPavilionStore];
	}

	static calculateState(state, props)
	{
		let selected = SelectedPavilionStore.getSelectedPavilion();

		let newState = {title: ""};

		if (selected)
		{
			let pavilion = selected.name;

			let {stand: slug} = props.match.params;
			let stand = SelectedPavilionStore.getStand(slug);

			if (stand)
			{
				newState = {title: FairStore.getFairTitle([pavilion, stand.title])};
			}
		}

		return newState;
	}

	render()
	{
		let {title} = this.state;
		App.setPageTitle(title);
		return null;
	}
}

export default withRouter(Container.create(PavilionTitle, {withProps: true}));


// WEBPACK FOOTER //
// ./src/modules/components/paviliontitle.js